import { render, staticRenderFns } from "./ManualExtras.vue?vue&type=template&id=3185f65f&scoped=true"
import script from "./ManualExtras.vue?vue&type=script&lang=js"
export * from "./ManualExtras.vue?vue&type=script&lang=js"
import style0 from "./ManualExtras.vue?vue&type=style&index=0&id=3185f65f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3185f65f",
  null
  
)

export default component.exports